export function SubprocessorsPage() {
  return (
    <>
      <header className="nk-header" id="home">
        <div className="section section-lg section-b-0">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  <div className="position-relative text-center">
                    <h2 className="title text-gradient-heading fw-semibold display-6 mb-4">
                      Subprocessors
                    </h2>
                    <p className="fs-8">
                      Yapamar engages the following trusted service providers as
                      subprocessors to support delivery of the platform. Each
                      subprocessor is vetted for security and privacy compliance
                      prior to onboarding.
                    </p>
                    <p className="fs-10 text-muted fw-semibold">
                      Last updated: October 14, 2026
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="nk-main">
        <div className="section section-xl section-t-0">
          <div className="section-content">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-8">
                  <div className="nk-entry">
                    <h5>Current Subprocessors</h5>
                    <ul>
                      <li>Amazon Web Services, Inc.</li>
                      <li>Amplitude, Inc.</li>
                      <li>Sentry (Functional Software, Inc.)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
